module.exports = __webpack_public_path__ + "img/afpi.49ba14ec.png";